/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationIPWhitelist } from './OrganizationIPWhitelist';
import {
    OrganizationIPWhitelistFromJSON,
    OrganizationIPWhitelistFromJSONTyped,
    OrganizationIPWhitelistToJSON,
} from './OrganizationIPWhitelist';

/**
 * 
 * @export
 * @interface FindAllOrganizationIPWhitelistResponseData
 */
export interface FindAllOrganizationIPWhitelistResponseData {
    /**
     * 
     * @type {string}
     * @memberof FindAllOrganizationIPWhitelistResponseData
     */
    organization_id?: string;
    /**
     * 
     * @type {Array<OrganizationIPWhitelist>}
     * @memberof FindAllOrganizationIPWhitelistResponseData
     */
    whitelist?: Array<OrganizationIPWhitelist>;
    /**
     * 
     * @type {number}
     * @memberof FindAllOrganizationIPWhitelistResponseData
     */
    count?: number;
}

/**
 * Check if a given object implements the FindAllOrganizationIPWhitelistResponseData interface.
 */
export function instanceOfFindAllOrganizationIPWhitelistResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllOrganizationIPWhitelistResponseDataFromJSON(json: any): FindAllOrganizationIPWhitelistResponseData {
    return FindAllOrganizationIPWhitelistResponseDataFromJSONTyped(json, false);
}

export function FindAllOrganizationIPWhitelistResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllOrganizationIPWhitelistResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization_id': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'whitelist': !exists(json, 'whitelist') ? undefined : ((json['whitelist'] as Array<any>).map(OrganizationIPWhitelistFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function FindAllOrganizationIPWhitelistResponseDataToJSON(value?: FindAllOrganizationIPWhitelistResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organization_id,
        'whitelist': value.whitelist === undefined ? undefined : ((value.whitelist as Array<any>).map(OrganizationIPWhitelistToJSON)),
        'count': value.count,
    };
}

